export default __webpack_public_path__ + "static/media/ic_coingecko_hover_16.69b3569d.svg";